import TravelGuides from './TravelGuides.component';
export default TravelGuides;